import React from "react";

export default function DigitalClock({ time, fullscreen }) {
    const hours = String(time.getHours()).padStart(2, "0");
    const minutes = String(time.getMinutes()).padStart(2, "0");
    const seconds = String(time.getSeconds()).padStart(2, "0");

    const date = time.toLocaleDateString("fr-FR", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <div className="text-center">
            <div
                className={`font-bold mb-2 font-mono ${fullscreen ? "text-[13vw] text-white" : "text-5xl sm:text-7xl text-logoa-700"}`}
                aria-live="polite"
                aria-atomic="true"
                aria-label={`Il est ${hours} heures ${minutes} minutes et ${seconds} secondes`}
            >
                <span>{hours}</span>
                <span className="">:</span>
                <span>{minutes}</span>
                <span className="">:</span>
                <span>{seconds}</span>
            </div>
            <div className={`font-semibold capitalize ${fullscreen ? "text-2xl sm:text-4xl text-gray-300" : "text-lg sm:text-xl text-gray-600"}`}>
                {date}
            </div>
        </div>
    );
}
